module.exports = __webpack_public_path__ + "media/success1.14a5bc11.wav";